  <template>
     <div>
        <el-select v-model="proveVlue" placeholder="请选择" :style='{width:setWidthPx,marginRight:right*1+"px"}' @change="selectProvince">
          <el-option  v-for="item in optionsProve"  :key="item.adcode" :label="item.name" :value="item.adcode"></el-option>
        </el-select>
        <el-select v-model="cityVal" placeholder="请选择" :style='{width:setWidthPx,marginRight:right*1+"px"}' @change="selectCity">
          <el-option v-for="item in optionsCity"  :key="item.adcode" :label="item.name"  :value="item.adcode"></el-option>
        </el-select>
        <el-select v-model="countyVal" placeholder="请选择" :style='{width:setWidthPx,marginRight:right*1+"px"}' @change="selectCounty">
          <el-option v-for="item in optionCounty" :key="item.adcode" :label="item.name" :value="item.adcode"></el-option>
        </el-select>
     </div>
  </template>
  <script>
  import list from './index';
  export default {
    props:{
      method:{
        type:Function,
        default:null
      },
      width:{
        type:String,
        default:140+''
      },
      right:{
        type:String,
        default:5+''
      },
      keyVal:{
         type:String,
         default:"key",
      }
    },
    computed:{
      setWidthPx(){
        let width = this.width.includes('%') ? this.width : this.width + 'px';
        return width;
      }
    },
    data(){
      return {
        value:"",
        optionsList:[],   //整体数据的值

        optionsProve: [],     //省份的数据列表值
        proveVlue:"",         //获取默认值
        
        optionsCity:[],       //市区的数据
        cityVal:'',           //市区的默认值
        
        optionCounty:[],      //县的数据
        countyVal:"",         //县的默认值

      };
    },
    created(){
       this.optionsList = list.address[0].districts
       this.getDate()
    },
    methods: {
      
      //获取默认值初次选中的初始化
      getDate(){
         this.optionsProve = this.optionsList
        //  this.proveVlue = this.optionsProve[0].adcode
        //  this.optionsCity = this.optionsProve[0].districts
        //  this.cityVal = this.optionsCity[0].adcode
        //  this.optionCounty = this.optionsCity[0].districts
        //  this.countyVal = this.optionCounty[0].adcode
      },
      
      //选取省份的值
      selectProvince(ev){
        this.proveVlue = ev   //省份选中的值
        let list = this.optionsList
        for(var i in list){
           if(list[i].adcode == ev){
             this.optionsCity = list[i].districts
             this.cityVal = this.optionsCity[0].adcode
             this.optionCounty = this.optionsCity[0].districts
             this.countyVal = this.optionCounty[0].adcode
           } 
        }
        this.getVal() 
      },
      //获取市区
      selectCity(ev){
        this.cityVal = ev     //市区选中的值
        let list = this.optionsCity
        for(var i in list){
           if(list[i].adcode == ev){
              this.optionCounty =  list[i].districts
              this.countyVal = this.optionCounty[0].adcode
           } 
        }
        this.getVal()
      },

      //选取县区
      selectCounty(ev){
         this.countyVal = ev
         this.getVal()
      },

      //获取选中的值
      getVal(){
       let adcodeArray = [this.proveVlue,this.cityVal,this.countyVal]
       let optionsProve = this.optionsProve
       let optionsCity = this.optionsCity
       let optionCounty = this.optionCounty
       let results = {
           keyVal:this.keyVal,
           DCodeVal:adcodeArray
       }   
       for(var i in optionsProve){
          if(adcodeArray[0]==optionsProve[i].adcode){
            delete optionsProve[i].citycode;
            
            delete optionsProve[i].level;
            results.AProve = optionsProve[i]  
          }
       }
       for(var j in optionsCity){
          if(adcodeArray[1]==optionsCity[j].adcode){
              delete optionsCity[j].citycode;
              
              delete optionsCity[j].level;
              results.BCity = optionsCity[j]  
          }
       }
       for(var h in optionCounty){
          if(adcodeArray[2]==optionCounty[h].adcode){
            delete optionCounty[h].citycode;
           
            delete optionCounty[h].level;
            results.COunty = optionCounty[h]  
          }
       }
       this.$emit("getVal",results)
      },

      //清空默认值
      clearBtn(){
          this.proveVlue = ""
          this.cityVal = ""
          this.optionsCity = []
          this.countyVal = ""
          this.optionCounty = []
      },

      //设置回显的值
      setVal(ev){
        // let ev = ['230000', '232700', '232701']  回显值得传参方式
        this.proveVlue = ev[0]
        this.cityVal = ev[1]
        this.countyVal = ev[2]
        let optionsProve = this.optionsProve
        for(var i in optionsProve){
            if(optionsProve[i].adcode == this.proveVlue){
               this.optionsCity = optionsProve[i].districts
               let optionsCity = optionsProve[i].districts
               for(var j in optionsCity){
                   if(optionsCity[j].adcode==this.cityVal){
                     this.optionCounty = optionsCity[j].districts
                     this.getVal()
                     break;
                   }
              }
          }
        }
      },
    }
  };
  </script> 
  <style>

  </style>